function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { ArrowLeft } from '@finect/tabular-icons/arrowLeft';
import { ChevronDown } from '@finect/tabular-icons/chevronDown';
import { Button } from '@finect/tabular-core/Button';
import { Link } from 'react-router-dom';
import { LikeAction } from './LikeAction';
import { InsideNavigationContainer, InsideNavigationInner, NavBack, NavOption, NavOptionLink, NavSubOptionLink, NavSelectBlock, NavSelect, NavTitle, ActionsBlock } from './partials';
export var InsideNavigation = function (_React$Component) {
  _inherits(InsideNavigation, _React$Component);
  var _super = _createSuper(InsideNavigation);
  function InsideNavigation() {
    var _this;
    _classCallCheck(this, InsideNavigation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "filterSelect", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      reveal: true,
      currentPath: null
    });
    _defineProperty(_assertThisInitialized(_this), "clickNav", function (hash) {
      if (hash && typeof hash === 'string') {
        var element = document.getElementById(hash);
        element && element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOmniNavChange", function (event) {
      _this.setState({
        reveal: ['opened'].includes(event.detail)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var _this$props = _this.props,
        withSPA = _this$props.withSPA,
        _this$props$history = _this$props.history,
        history = _this$props$history === void 0 ? null : _this$props$history;
      _this.setState({
        currentPath: _this.filterSelect.value
      });
      withSPA && history ? history.push(_this.filterSelect.value) : window.location.href = _this.filterSelect.value;
    });
    return _this;
  }
  _createClass(InsideNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('OmniNavStateChanged', this.handleOmniNavChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('OmniNavStateChanged', this.handleOmniNavChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var reveal = this.state.reveal;
      var _this$props2 = this.props,
        links = _this$props2.links,
        _this$props2$currentP = _this$props2.currentPath,
        currentPath = _this$props2$currentP === void 0 ? '' : _this$props2$currentP,
        back = _this$props2.back,
        noBackIcon = _this$props2.noBackIcon,
        action = _this$props2.action,
        _onFollow = _this$props2.onFollow,
        following = _this$props2.following,
        withSPA = _this$props2.withSPA,
        _this$props2$position = _this$props2.position,
        position = _this$props2$position === void 0 ? 'fixed' : _this$props2$position;
      var current = links.find(function (item) {
        return (_this2.state.currentPath || currentPath) === item.path;
      }) || links.find(function (item) {
        return (_this2.state.currentPath || currentPath).startsWith(item.path);
      });
      var title = this.props.title ? this.props.title : null;
      return React.createElement(InsideNavigationContainer, {
        reveal: reveal,
        position: position
      }, React.createElement(InsideNavigationInner, null, React.createElement("nav", null, back ? React.createElement(NavBack, _extends({
        "data-fi-event": "insideNavigation-back",
        datanobackicon: !noBackIcon ? 'true' : 'false'
      }, withSPA ? {
        as: Link,
        to: back.path
      } : {
        href: back.path
      }), !noBackIcon ? React.createElement(ArrowLeft, {
        size: "22",
        strokeWidth: "1.8"
      }) : '', back.title) : null, title && !reveal && !action ? React.createElement(NavTitle, null, title) : '', links.length !== 0 && links.map(function (link, index) {
        var isSelected = (link === null || link === void 0 ? void 0 : link.path) === currentPath || currentPath.startsWith(link === null || link === void 0 ? void 0 : link.path);
        if (!link.sublinks) {
          var linkProps = _this2.props.withSPA ? link.hash ? {
            onClick: function onClick() {
              return _this2.clickNav(link.hash);
            }
          } : {
            as: Link,
            to: link === null || link === void 0 ? void 0 : link.path
          } : {
            href: link === null || link === void 0 ? void 0 : link.path
          };
          if (link.rel) linkProps.rel = link.rel;
          return React.createElement(NavOptionLink, _extends({
            "data-fi-event": "insideNavigation",
            onClick: _this2.clickNav,
            key: index,
            selected: isSelected
          }, linkProps), link.title);
        }
        var currentSection = isSelected ? link.sublinks.find(function (item) {
          return item.path === currentPath;
        }) : null;
        return React.createElement(NavOption, {
          key: index,
          selected: isSelected,
          back: back
        }, link.title, currentSection ? React.createElement("span", null, ": ", currentSection.title) : null, React.createElement(ChevronDown, {
          size: "16",
          strokeWidth: "2.4"
        }), React.createElement("ul", null, link.sublinks && link.sublinks.map(function (sublink, subindex) {
          var sublinkProps = _this2.props.withSPA ? sublink.hash ? {
            onClick: function onClick() {
              return _this2.clickNav(sublink.hash);
            }
          } : {
            as: Link,
            to: sublink === null || sublink === void 0 ? void 0 : sublink.path
          } : {
            href: sublink === null || sublink === void 0 ? void 0 : sublink.path
          };
          return React.createElement("li", {
            key: subindex
          }, React.createElement(NavSubOptionLink, _extends({
            title: sublink.title,
            onClick: _this2.clickNav,
            selected: (sublink === null || sublink === void 0 ? void 0 : sublink.path) === currentPath
          }, sublinkProps), sublink.title));
        })));
      }), !action && links.length !== 0 ? React.createElement(NavSelectBlock, null, React.createElement(NavSelect, {
        onChange: this.handleChange,
        ref: function ref(article) {
          return _this2.filterSelect = article;
        },
        value: current && current.path
      }, links.map(function (link, index) {
        return React.createElement("option", {
          key: index,
          value: link === null || link === void 0 ? void 0 : link.path
        }, link.title);
      })), React.createElement(ChevronDown, {
        size: "16",
        strokeWidth: "2.4"
      })) : null), React.createElement(ActionsBlock, null, _onFollow ? React.createElement(LikeAction, {
        following: following,
        onFollow: function onFollow() {
          return _onFollow(!following);
        }
      }) : null, action ? React.createElement(Button, {
        disabled: action.disabled,
        width: "auto",
        onClick: function onClick() {
          action.onClick();
        },
        secondary: true,
        variant: "medium"
      }, action.text) : null)));
    }
  }]);
  return InsideNavigation;
}(React.Component);
_defineProperty(InsideNavigation, "defaultProps", {
  noBackIcon: false,
  withSPA: false
});